import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05d77252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu_wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InitialIcon = _resolveComponent("InitialIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_InitialIcon, {
      icon: "initialPage/newAi.svg",
      title: "Criar nova IA",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-new', $event)))
    }),
    _createVNode(_component_InitialIcon, {
      icon: "initialPage/mngProj.svg",
      title: "Gerenciar projetos",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click-mng', $event)))
    }),
    _createVNode(_component_InitialIcon, {
      icon: "initialPage/connection.svg",
      title: "Cloud e serviços externos",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click-cloud', $event)))
    }),
    _createVNode(_component_InitialIcon, {
      icon: "initialPage/painter.svg",
      title: "Contribua conosco!",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click-contrib', $event)))
    }),
    _createVNode(_component_InitialIcon, {
      icon: "initialPage/recommendations.svg",
      title: "Dados e Dashboards",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click-data', $event)))
    })
  ]))
}